// JavaScript Document
( function( $ ) {
  // スマホナビ開閉とBODYの固定
  $(function () {
    var flag = false;
    var menuBtn = $('.menuBtn');

    //menuボタンが押された処理（開閉時）
    menuBtn.on('click', function(){
      if (flag == false) {
        bodyFix(); //bodyを固定
        $('#gnaviWrap').addClass('open');
        $('.menuBtn').addClass('close-btn');
        flag = true;
      }else{
        closeNavi();
        flag = false;
      }
    });
  });
 
  //ナビを閉じるときの関数
  function closeNavi(){
    bodyFixReset(); //body固定を解除
    $('#gnaviWrap').removeClass('open');
    $('.menuBtn').removeClass('close-btn');
  }
 
  //以下、bodyを固定する関数
  var scrollPosi;
  function bodyFix(){
    scrollPosi = $(window).scrollTop();
	$('body').addClass('fixed').css({'top': -scrollPosi});
  }

  //以下、body固定を解除する関数
  function bodyFixReset(){
    $('body').removeClass('fixed').css({'top': 'auto'});
	$('html, body').scrollTop(scrollPosi);
  }


  // グローバルナビゲーションの挙動
  $(window).resize(function() {
	var winW = window.innerWidth;
	var devW = 1024;
	if (winW >= devW) {
		$('#gnaviWrap .parentMenu').on('mouseover',function(){
			$(this).children('.submenuWrap').stop().slideDown().css('z-index','2');
			$(this).addClass('open');
			$('body').addClass('overlay');
		}).on('mouseout',function(){
			$(this).children('.submenuWrap').stop().slideUp(500).css('z-index','0');
			$(this).removeClass('open');
			$('body').removeClass('overlay');
		});
	}
  }).resize();
  $(function(){
	var toggleBtn = $('#gnaviWrap .parentMenu .toggleBtn');

	toggleBtn.on('click', function(){
		var winW = window.innerWidth;
		if (winW <= 1024) {
			$(this).toggleClass('active');
			if($(this).next('.submenuWrap').is(':visible')) {
				$(this).next('.submenuWrap').stop().slideUp(300);
			} else {
				$(this).next('.submenuWrap').stop().slideDown(300).css('display','block');
			}
			$(this).parent('.parentMenu').siblings().children('.toggleBtn').removeClass('active');
			$(this).parent('.parentMenu').siblings().children('.submenuWrap').stop().slideUp(300);
		}
	});
  });

  //スムーススクロール
  $(function(){
	var notList = '#back_to_top .js-back_to_top, .smodal, .tabItem a, .fgotop, .productCvTop .linkBtn a';
	var headerHight = 120;
	$('a[href^="#"]' + 'a,area').not(notList).click(function() {
		var speed = 400; //ここはお好きな数値に変えてください
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - headerHight;
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
  });


  //go top
  $(function() {
	var topBtn = $('#back_to_top, .fgotop');
    topBtn.hide();

  // スクロールが100に達したらボタン表示
  $(window).scroll(function () {
    var scrollPos = $(this).scrollTop();

    if (scrollPos > 500 ) {
      // ボタンの表示方法
      topBtn.fadeIn();
    } else {
      // ボタンの非表示方法
      topBtn.fadeOut();
    }
  });
	
	//スクロールしてトップ
	topBtn.click(function () {
		$('body,  html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
  });


  $(window).on('load', function(){
  var toggleBtn = $('.accordionBox .targetBtn');

  toggleBtn.each(function() {
    var acdInner = $(this).next('.acdInner');
    if ($(this).hasClass('active')) {
      acdInner.css('display','block');
    } else {
      acdInner.css('display','none');
    }
  });

  toggleBtn.on('click', function(){
    var acdInner = $(this).next('.acdInner');
    if (acdInner.is(':visible')) {
      acdInner.stop().slideUp(300);
      $(this).removeClass('active');
    } else {
      acdInner.stop().slideDown(300);
      $(this).addClass('active');
    }
  });
});


  //animation
  $(function() {
    $('body').fadeIn(500);
	if($('#cheader').length){
		setTimeout(function(){
			$('#cheader').addClass('active');
		}, 600);
	}
  });

  $(window).on('load scroll resize', function () {
	var st = $(window).scrollTop();
	var wh = $(window).height();
	$('.fade').each(function () {
		var tg = $(this).offset().top - wh * 0.9;

		if (st > tg) {
			$(this).addClass("active");
		} else {
			$(this).removeClass("active");
		}
	});
	$('.upfade, .downfade, .sclin_right, .sclin_left').each(function () {
		var tg = $(this).offset().top - wh * 0.8;

		if (st > tg) {
			$(this).addClass('scrollin');
		} else {
			$(this).removeClass('scrollin');
		}
	});
	$('.listfade li').each(function (i) {
		var delay = 100;
		var tg = $(this).offset().top - wh * 1;
		var $this = $(this);
		if (st > tg) {
			$this.delay(i * delay).queue(function(next) {
				$this.addClass('scrollin');
				next();
			});
		}
	});
  });


  // 変数に要素を入れる
var trigger = $('.modal__trigger'),
    wrapper = $('.modal__wrapper'),
    layer = $('.modal__layer'),
    container = $('.modal__container'),
    close = $('.modal__close');

// 『モーダルを開くボタン』をクリックしたら、『モーダル本体』を表示
$(trigger).click(function() {
  var index = $(this).index();
  $(wrapper).eq(index).fadeIn(400);

  // スクロール位置を戻す
  $(container).scrollTop(0);

  // サイトのスクロールを禁止にする
  $('html, body').css('overflow', 'hidden');
});

// 『背景』と『モーダルを閉じるボタン』をクリックしたら、『モーダル本体』を非表示
$(layer).add(close).click(function() {
  $(wrapper).fadeOut(400);

  // サイトのスクロール禁止を解除する
  $('html, body').removeAttr('style');
});
    
  var touch = 'ontouchstart' in document.documentElement
            || navigator.maxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0;
 
if (touch) { // remove all :hover stylesheets
    try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;
 
            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                if (!styleSheet.rules[ri].selectorText) continue;
 
                if (styleSheet.rules[ri].selectorText.match(':hover')) {
                    styleSheet.deleteRule(ri);
                }
            }
        }
    } catch (ex) {}
}

  $(function() {
  $(".header__icon--menu").click(function() {
    $(".header__icon--account").toggleClass("open");
    $(".header__icon--cart").toggleClass("open");
  });
});

$(window).scroll(function () {
  if($(window).scrollTop() > 40) {
    $('.header-wrapper').addClass('is-active');
  } else {
    $('.header-wrapper').removeClass('is-active');
  }
});

  $(function() {
  var topCvArea = $('.c-cvArea, .productCvArea');    
  topCvArea.hide();

  // スクロールが100に達したらボタン表示
  $(window).scroll(function () {
    var scrollPos = $(this).scrollTop();
    var windowHeight = $(window).height();
    var documentHeight = $(document).height();

    if (scrollPos > 500) {
      // ボタンの表示方法
      topCvArea.fadeIn();
    } else {
      // ボタンの非表示方法
      topCvArea.fadeOut();
    }
  });
});

    

}( jQuery ) ); // jQuery End

/*----------------------------------------------
	ScrollTrigger
------------------------------------------------*/



  // フェードイン
  gsap.utils.toArray(".js_fadein").forEach(target => {
    gsap.fromTo(target, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        toggleActions: "play none none reset",
      },
    });
  });

  // フェードイン 遅め
  gsap.utils.toArray(".js_fadein_slow").forEach(target => {
    gsap.fromTo(target, 1.0, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        toggleActions: "play none none reset",
      },
    });
  });


  // フェードアップ
  gsap.utils.toArray(".js_up").forEach(target => {
    gsap.fromTo(target, {
      autoAlpha: 0,
      y: 50,
    }, {
      autoAlpha: 1,
      y: 0,
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        toggleActions: "play none none reset",
      },
    });
  });


  // フェードダウン
  gsap.utils.toArray(".js_down").forEach(target => {
    gsap.fromTo(target, {
      autoAlpha: 0,
      y: -50,
    }, {
      autoAlpha: 1,
      y: 0,
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        toggleActions: "play none none reset",
      },
    });
  });


  // ULの子要素がそれぞれターゲットエリアに入った時にフェードアップ
  gsap.utils.toArray(".js_listfade li").forEach(target => {
	gsap.from(target, {
		y: 50,
		opacity: 0,
		scrollTrigger: {
			trigger: target,
			start: "top 70%",
			toggleActions: "play none none reset",
		},
		stagger: {
			from: "start",
			amount: 1
		},
	});
  });


  // 同じclassが付いているものを時差を付けてフェードアップ
  gsap.set(".batch_fadeup", {autoAlpha: 0, y: 50});
  ScrollTrigger.batch('.batch_fadeup', {
    duration: 1,
    interval: 0.1,
    batchMax: 3,
	start: 'top 70%',
    onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.5 }),
    onLeave: batch => gsap.set(batch, {autoAlpha: 0, y: 50, overwrite: true}),
    onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.5, }),
    onLeaveBack: batch => gsap.set(batch, {autoAlpha: 0, y: 50, overwrite: true})
  });

